import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { boxApi } from '../utils/api'
import AlertModal from './AlertModal'

export default function InviteMembers({ boxId, boxName, onInviteSent }) {
  const [submitting, setSubmitting] = useState(false)
  const [modalState, setModalState] = useState({
    open: false,
    type: 'info',
    title: '',
    message: '',
  })
  
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  const onSubmit = async (data) => {
    try {
      setSubmitting(true)
      setModalState((prev) => ({ ...prev, open: false }))

      await boxApi.createInvitation(boxId, {
        email: data.email,
        name: data.name,
      })

      setModalState({
        open: true,
        type: 'success',
        title: 'Invitation Sent',
        message: `An invitation was sent to ${data.email}.`,
      })
      reset()
      onInviteSent?.()
    } catch (err) {
      setModalState({
        open: true,
        type: 'error',
        title: 'Unable to Send Invitation',
        message: err.message || 'Please try again.',
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="bg-white shadow-xl rounded-2xl border border-gray-100 p-6">
      <AlertModal
        open={modalState.open}
        type={modalState.type}
        title={modalState.title}
        message={modalState.message}
        actionLabel="Got it"
        onClose={() => setModalState((prev) => ({ ...prev, open: false }))}
      />
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Invite Members to {boxName}
      </h3>
      <p className="text-sm text-gray-600 mb-6">
        Send email invitations to people you want to join this box. They&apos;ll receive a link to accept the invitation.
      </p>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <div>
          <label htmlFor="name" className="block text-base font-semibold text-gray-900 mb-2">
            Name
          </label>
          <input
            type="text"
            id="name"
            {...register('name')}
            className="block w-full px-4 py-3 text-base border border-gray-200 rounded-2xl shadow-sm bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
            placeholder="Optional: Member's name"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-base font-semibold text-gray-900 mb-2">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="email"
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
            })}
            className="block w-full px-4 py-3 text-base border border-gray-200 rounded-2xl shadow-sm bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
            placeholder="member@example.com"
          />
          {errors.email && (
            <p className="mt-2 text-sm text-red-600">{errors.email.message}</p>
          )}
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="w-full px-6 py-3 border border-transparent rounded-full shadow-sm text-base font-semibold text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {submitting ? 'Sending...' : 'Send Invitation'}
        </button>
      </form>
    </div>
  )
}
